import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import SecureImage from "@/components/SecureImage";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function PhotosTab({ clientId }) {
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [viewing, setViewing] = useState(null);
  const fileRef = useRef(null);

  const load = async () => {
    try { const { data } = await api.get(`/clients/${clientId}/photos`); setPhotos(data); }
    catch { toast.error("Failed to load photos"); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [clientId]);

  const upload = async (files) => {
    if (!files || !files.length) return;
    setUploading(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post(`/clients/${clientId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success("Photo uploaded");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Upload failed"); }
    setUploading(false);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="font-display text-2xl uppercase">Physique Photos</div>
          <div className="text-xs text-zinc-500 uppercase tracking-[0.2em] mt-1">Private. Visible only to you and your coach.</div>
        </div>
        <div>
          <input ref={fileRef} hidden type="file" accept="image/*" multiple onChange={(e) => upload(Array.from(e.target.files || []))} data-testid="photo-file-input" />
          <Button data-testid="upload-photo-btn" onClick={() => fileRef.current?.click()} disabled={uploading} className="rounded-none bg-[#FF3B30] hover:bg-[#D63028] text-white uppercase tracking-[0.2em] h-10 text-xs">
            {uploading ? "Uploading..." : "+ Upload Photo"}
          </Button>
        </div>
      </div>
      {photos.length === 0 ? (
        <div className="border border-dashed border-zinc-800 p-16 text-center text-zinc-500 text-sm">No photos yet. Upload to track your progress.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {photos.map(p => (
            <button key={p.id} onClick={() => setViewing(p)} data-testid={`photo-${p.id}`} className="group relative aspect-[3/4] overflow-hidden border border-zinc-800 hover:border-[#FF3B30] transition">
              <SecureImage path={p.storage_path} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-3 text-[10px] uppercase tracking-[0.3em] text-zinc-300 text-left">
                {new Date(p.created_at).toLocaleDateString()}
              </div>
            </button>
          ))}
        </div>
      )}
      {viewing && (
        <div onClick={() => setViewing(null)} className="fixed inset-0 z-50 bg-black/95 grid place-items-center p-6 cursor-zoom-out" data-testid="photo-modal">
          <SecureImage path={viewing.storage_path} className="max-h-[90vh] max-w-full object-contain" />
        </div>
      )}
    </div>
  );
}
